module.exports = __webpack_public_path__ + "img/u186.0b0ad2d9.png";